export function getFeedbackIntegrationOptions() {
    return {
        autoInject: false,
        showBranding: false,
        colorScheme: 'system' as const,
        showName: false,
        showEmail: false,
        useSentryUser: {name: 'name', email: 'email'},
        enableScreenshot: true,
        formTitle: 'Send Feedback',
        submitButtonLabel: 'Send Feedback',
        messagePlaceholder: 'What happened? What did you expect?',
    }
}
